import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteMonitorError } from "@/api/monitor";
import { MonitorQueryKeys } from "@/tanstackQuery/queries/monitor";

export const useDeleteMonitorError = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (fingerprint: string) => deleteMonitorError(fingerprint),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [MonitorQueryKeys.ErrorsPaginated],
      });
      queryClient.invalidateQueries({
        queryKey: [MonitorQueryKeys.ErrorDetail],
      });
    },
  });
};
